import { type RefObject, useCallback } from 'react'

export const useOverlayContainer = (targetRef: RefObject<HTMLElement | null>) =>
  useCallback(() => targetRef.current?.closest<HTMLElement>('.modal') ?? document.body, [targetRef])
